import React, { useState } from 'react';
import { Settings2, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import './ToolWorkspace.css';

const ToolWorkspace = ({ 
    sidebarContent, 
    canvasContent, 
    title = "AI Tool",
    actions 
}) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <div className="tool-workspace">
            
            {/* --- 1. DESKTOP SIDEBAR --- */}
            <aside className="workspace-sidebar desktop-only">
                {/* ★ DELETED THE DUPLICATE HEADER HERE ★ */}
                
                {/* Just render the content directly */}
                <div className="sidebar-scroll-area">
                    {sidebarContent}
                </div>
            </aside>

            {/* --- 2. MAIN CANVAS AREA --- */}
            <main className="workspace-main">
                <div className="mobile-tool-header mobile-only">
                    <h3>{title}</h3>
                    <button 
                        className="btn-mobile-settings"
                        onClick={() => setIsMobileMenuOpen(true)}
                    >
                        <Settings2 size={20} />
                        <span>Adjust</span>
                    </button>
                </div>

                <div className="canvas-container">
                    {canvasContent}
                </div>
            </main>

            {/* --- 3. MOBILE SHEET --- */}
            <AnimatePresence>
                {isMobileMenuOpen && (
                    <>
                        <motion.div 
                            className="mobile-backdrop"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setIsMobileMenuOpen(false)}
                        />
                        <motion.div 
                            className="mobile-sheet"
                            initial={{ y: "100%" }}
                            animate={{ y: 0 }}
                            exit={{ y: "100%" }}
                            transition={{ type: "spring", damping: 25, stiffness: 300 }}
                        >
                            <div className="sheet-handle-bar" onClick={() => setIsMobileMenuOpen(false)}>
                                <div className="sheet-handle"></div>
                            </div>
                            <div className="sheet-header">
                                <h3>Tool Settings</h3>
                                <button onClick={() => setIsMobileMenuOpen(false)}>
                                    <X size={20} />
                                </button>
                            </div>
                            <div className="sheet-content">
                                {sidebarContent}
                            </div>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ToolWorkspace;